"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedTokensForFallbackTheme = void 0;
var camelize_1 = require("./camelize");
var lowerFirstLetter_1 = require("./lowerFirstLetter");
var getFormattedTokensForFallbackTheme = function (array) {
    return Object.entries(array).reduce(function (acc, _a) {
        var _b;
        var token = _a[0], value = _a[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[(0, lowerFirstLetter_1.lowerFirstLetter)((0, camelize_1.camelize)(token) || '')] = {
            value: value,
        }, _b)));
    }, {});
};
exports.getFormattedTokensForFallbackTheme = getFormattedTokensForFallbackTheme;
//# sourceMappingURL=getFormattedTokensForFallbackTheme.js.map